import { DATE_FORMAT, FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { CustomDate } from '../CustomDate';
import { QueryBuilder } from '../QueryBuilder';
import { TimeInterval } from '../TimeInterval';
import { MetricFilter } from './MetricFilter';

export class EndDateFilter extends MetricFilter<TimeInterval> {
  public field = 'end_date';
  public operator = FilterOperator.LTE;

  constructor(timeInterval: TimeInterval[]) {
    super(timeInterval);
  }

  public value(): string {
    return new CustomDate().formatDate(DATE_FORMAT.YYYY_MM_DD);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    if (!this.values) return false;
    const newFilter = newQueryBuilder.filters.find((currentFilter) => this.field === currentFilter.field);
    if (!newFilter) return true;
    return this.values[0].isLower((newFilter as EndDateFilter).values[0]);
  }

  public merge(newFilter: EndDateFilter): this {
    if (!(newFilter instanceof EndDateFilter)) return this;
    //FIXME: Implement this in the future
    return this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    //FIXME: Implement this in the future
    return metrics;
  }
}
